import {
  sagaListSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";
import { setTime } from "../utils/DateHelpers";
import moment from "moment";
import { remove } from "lodash";
import R from "ramda";

const EVENTS = "events";
const EVENT = "event";

const initialState = {
  list: [],
  currentEvent: {},
  showEventModal: false
};

const transformToCalendarDates = event => {
  event.start = new Date(event.start_date);
  event.end = new Date(event.end_date);
  event.event_type = event.event_type || "regular";
  return event;
};

const transformToFormDate = event => {
  event.event_start_date = event.start_date;
  event.event_end_date = event.end_date;
  event.start_time = setTime(moment(), moment(event.start_date));
  event.end_time = setTime(moment(), moment(event.end_date));
  return event;
};

const eventSorter = (a, b) => a.start < b.start;

const transform = event => {
  if (event.eventable_type === "Service") {
    event.event_type = "sunday_service";
  } else {
    event.event_type = "regular";
  }
  return event;
};

export default function events(state = initialState, action = {}) {
  switch (action.type) {
    case "HIDE_EVENT_MODAL":
      return { ...state, showEventModal: false };
    case "NEW_EVENT":
      return { ...state, showEventModal: true, currentEvent: {} };
    case "EDIT_EVENT":
      return {
        ...state,
        showEventModal: true,
        currentEvent: transformToFormDate(action.data)
      };
    case sagaListSuccess(EVENTS):
      const events = action.data.data
        .map(transformToCalendarDates)
        .sort(eventSorter);
      const _events = R.map(transform, events);
      return { ...state, list: _events };
    // case sagaOneSuccess(EVENT):
    //   return { ...state, currentEvent: action.data.data };
    case sagaCreateSuccess(EVENT):
      const current = transform(transformToCalendarDates(action.data.data));
      state.list.push(current);
      state.list.sort(eventSorter);
      return { ...state, currentEvent: current };
    case sagaUpdateSuccess(EVENT):
      let updatedEvent = action.data.data;
      remove(state.list, x => x.id === updatedEvent.id);
      state.list.push(transformToCalendarDates(updatedEvent));
      state.list.sort(eventSorter);
      return {
        ...state,
        currentEvent: transform(transformToCalendarDates(action.data.data))
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/events.js